import { Field } from 'redux-form';

import { TextField, SelectField } from 'common/components/forms';
import { listAllCountriesOptionArray } from 'common/helpers/addresses';
import { getMessage } from 'common/helpers/miscHelper';
import { phoneNormalize } from 'common/helpers/phoneHelper';

import CustomerDisplay from './CustomerDisplay';

const FormCustomer = (props) => {
  const { c7Form, customer, settings } = props;
  const { customerAttributes } = c7Form;
  const countryArray = listAllCountriesOptionArray(false);
  if (customer) {
    return <CustomerDisplay customer={customer} />;
  }
  return (
    <>
      {customerAttributes.firstName === 'required' && (
        <Field
          name="firstName"
          component={TextField}
          label="First Name"
          autocomplete="given-name"
          required
        />
      )}
      {customerAttributes.firstName === 'optional' && (
        <Field
          name="firstName"
          component={TextField}
          label="First Name"
          autocomplete="given-name"
        />
      )}
      {customerAttributes.lastName === 'required' && (
        <Field
          name="lastName"
          component={TextField}
          label="Last Name"
          autocomplete="family-name"
          required
        />
      )}
      {customerAttributes.lastName === 'optional' && (
        <Field
          name="lastName"
          component={TextField}
          label="Last Name"
          autocomplete="family-name"
        />
      )}

      {customerAttributes.countryCode === 'required' && (
        <Field
          name="countryCode"
          component={SelectField}
          optionArray={countryArray}
          label="Country"
          required
        />
      )}
      {customerAttributes.countryCode === 'optional' && (
        <Field
          name="countryCode"
          component={SelectField}
          optionArray={countryArray}
          label="Country"
        />
      )}

      {customerAttributes.phone === 'required' && (
        <Field
          name="phone"
          component={TextField}
          label="Phone"
          formType="tel"
          normalize={phoneNormalize}
          autocomplete="tel-national"
          required
        />
      )}
      {customerAttributes.phone === 'optional' && (
        <Field
          name="phone"
          component={TextField}
          label="Phone"
          formType="tel"
          autocomplete="tel-national"
          normalize={phoneNormalize}
        />
      )}

      <Field
        name="email"
        component={TextField}
        label="Email"
        autocomplete="email"
        required
      />
      {customerAttributes.emailMarketingStatus === 'optional' && (
        <>
          <Field
            name="emailMarketingStatus"
            component={SelectField}
            optionArray={emailMarketingStatusOptionArray()}
            label="Subscribe To Email Marketing?"
          />
          <div
            dangerouslySetInnerHTML={{
              __html: getMessage('Email Marketing Message', settings)
            }}
          />
        </>
      )}
    </>
  );
};

const emailMarketingStatusOptionArray = () => {
  const optionArray = [
    { value: '', option: '' },
    { value: 'Subscribed', option: 'Subscribed' },
    { value: 'Unsubscribed', option: 'Unsubscribed' }
  ];
  return optionArray;
};

export default FormCustomer;
